import FilterInTable from "../../../../../views/Manage/FilterInTable"
import BlueBadge from "../../../../common/AdminCommonComponents/BlueBadge/BlueBadge"
import ActionButton from "../../../../common/AdminCommonComponents/Buttons/ActionButton/ActionButton"
import DynamicDatatable from "../../../../common/AdminCommonComponents/DynamicDatatable/DynamicDatatable"

const Categories = ({ setToggleDetail }) => {
  const actions = [
    { label: "View Detail", action: () => setToggleDetail((prev) => ({ ...prev, category: !prev.category })) },
    { label: "Change Status", action: () => console.log("Change Status") },
    { label: "Delete", action: () => console.log("Delete") },
  ]

  const tableData = [
    {
      sr: "1",
      categoryId: "762789",
      categoryName: "Apparel & Accessories",
      description: "Lorem Ipsum",
      noOfSubCategories: "0",
      noOfProducts: "10",
      status: "In-stock",
    },
    {
      sr: "2",
      categoryId: "762789",
      categoryName: "Apparel & Accessories",
      description: "Lorem Ipsum",
      noOfSubCategories: "0",
      noOfProducts: "10",
      status: "In-stock",
    },
    {
      sr: "3",
      categoryId: "762789",
      categoryName: "Apparel & Accessories",
      description: "Lorem Ipsum",
      noOfSubCategories: "0",
      noOfProducts: "10",
      status: "In-stock",
    },
    {
      sr: "4",
      categoryId: "762789",
      categoryName: "Apparel & Accessories",
      description: "Lorem Ipsum",
      noOfSubCategories: "0",
      noOfProducts: "10",
      status: "In-stock",
    },
    {
      sr: "5",
      categoryId: "762789",
      categoryName: "Apparel & Accessories",
      description: "Lorem Ipsum",
      noOfSubCategories: "0",
      noOfProducts: "10",
      status: "In-stock",
    },
    {
      sr: "6",
      categoryId: "762789",
      categoryName: "Apparel & Accessories",
      description: "Lorem Ipsum",
      noOfSubCategories: "0",
      noOfProducts: "10",
      status: "In-stock",
    },
  ]

  const columns = [
    { name: "Sr.", selector: (row) => row.sr, grow: 0.5 },
    { name: "Category ID", selector: (row) => row.categoryId },
    { name: "Category Name", selector: (row) => row.categoryName },
    { name: "Description", selector: (row) => row.description },
    { name: "No. of Subcategories", selector: (row) => row.noOfSubCategories, center: 'true' },
    { name: "No. of Products", selector: (row) => <BlueBadge>{row.noOfProducts}</BlueBadge>, center: 'true' },
    { name: "Status", selector: (row) => row.status, center: 'true' },
    { name: "Action", cell: () => <ActionButton options={actions} />, center: 'true' },
  ]

  return (
    <>
      <FilterInTable componentName="Brand Management Product Overview" />
      <DynamicDatatable columns={columns} data={tableData} type="gray" pagination />
    </>
  )
}

export default Categories
